import { css } from 'linaria';

export const spaceoBannerLogo = css`
  object-fit: fill;

  @media (--from-tablet) {
    border-radius: 0;
  }

  @media (--only-mobile) {
    height: 193px;
  }
`;

export const textBlock = css`
  display: flex;
  align-items: center;
  width: 100%;
  padding: 32px 100px;

  @media (--only-largeDesktop) {
    justify-content: space-between;
  }

  @media (--only-desktop) {
    justify-content: flex-start;
    padding: 0;
  }

  @media (--only-tablet) {
    flex-direction: column;
    align-items: flex-start;
    padding: 25px 56px;
  }

  @media (--only-mobile) {
    flex-direction: column;
    align-items: flex-start;
    width: 189px;
    padding: 24px 16px;
  }
`;

export const spaceoBannerNameWrapper = css`
  display: flex;
  align-items: center;

  @media (--only-desktop) {
    padding: 0 40px;
  }

  @media (--only-tablet) {
    margin-bottom: 12px;
  }

  @media (--only-mobile) {
    margin-bottom: 16px;
  }
`;

export const spaceoBannerContent = css`
  justify-content: space-evenly;

  @media (--only-tablet) {
    padding: 25px 56px;
  }
`;

export const spaceoBannerName = css`
  && {
    @media (--only-tablet) {
      font-size: 20px;
      line-height: 26px;
    }

    @media (--only-mobile) {
      padding-right: 0;
      font-size: 18px;
      line-height: 24px;
    }
  }
`;

export const spaceoBannerNameChevronIcon = css`
  @media (--only-tablet) {
    width: 20px;
    height: 20px;
  }

  @media (--only-mobile) {
    display: none;
  }
`;

export const spaceoBannerList = css`
  display: flex;

  li {
    column-gap: 8px;
  }

  @media (--only-mobile) {
    flex-direction: column;
  }

  li:not(:last-child) {
    margin-right: 24px;
    margin-bottom: 0;

    @media (--only-mobile) {
      margin-right: 0;
      margin-bottom: 16px;
    }
  }
`;
